module.exports = __webpack_public_path__ + "static/media/lock.953e4d5e.svg";